module.exports = __webpack_public_path__ + "img/module2_item2_bg.36741ebb.jpg";